import { React, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import moment from 'moment';

import LockerOtherUsageView from './LockerOtherUsageView';
import LockerRefundInfoView from './LockerRefundInfoView';

// Image //
import MemberShipHistoryInfoWhiteButtonImagePath from '../../../../image/MemberShipHistoryInfoWhiteButton.png';
import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';
// Image //

export default function LockerHistoryInfoView(props) {
  const { t } = useLanguage();
  const {
    data,
    index,
    size,
    onClickLockerModify,
    onClickLockerExtends,
    onClickLockerExit,
    onClickLockerRefund,
    onClickDeleteLockerUsageHistory,
    onClickModifyLockerRefund,
    onClickDeleteLockerRefund,
    lockerRendering
  } = props;

  const [isClicked, setIsClicked] = useState(false);
  const [status, setStatus] = useState(t('memberDetail.statusInUse'));
  const [buttonImage, setButtonImage] = useState(MemberShipHistoryInfoButtonImagePath);
  const [fontColor, setFontColor] = useState('#595959');
  const [border, setBorder] = useState('1px solid #FFFFFF');
  const [hoverBorder, setHoverBorder] = useState('1px solid #FFFFFF');
  const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

  const OptionBoxRef = useRef(null);
  const OptionButtonRef = useRef(null);
  const OptionExitRef = useRef(null);
  const OptionPushMessageRef = useRef(null);
  const OptionDeleteRef = useRef(null);
  const OptionExtendRef = useRef(null);
  const OptionRefundRef = useRef(null);

  // 옵션 버튼 크기 설정 //
  useEffect(() => {
    if (OptionBoxRef.current === null) return;

    if (isClicked) {
      if (data.status === '사용중') OptionBoxRef.current.style.height = `144px`;
      else OptionBoxRef.current.style.height = `72px`;

      OptionBoxRef.current.style.border = `1px solid #FF8B48`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid #FF8B48`;
    }
  }, [isClicked, data])

  // 마우스 클릭 리스너 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 데이터 세팅 //
  useEffect(() => {
    if (data.status === '사용 종료') {
      setStatus(t('memberDetail.statusUsageEnded'));
      setFontColor('#777777');
      setBorder('1px solid #F8F8F8');
      setHoverBorder('1px solid #FF8B48');
      setBackgroundColor('#F8F8F8');
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    else if (data.status === '결제 예정') {
      setStatus(t('memberDetail.statusPaymentPending'));
      setFontColor('#777777');
      setBorder('1px solid #FDECC1');
      setHoverBorder('1px solid #FF8B48');
      setBackgroundColor('#FDECC1');
      setButtonImage(MemberShipHistoryInfoButtonImagePath);
    }
    else {
      // 사용 기한이 끝나지 않은 경우 //
      if (moment().isBefore(moment(data.scheduledEndDate))) {
        setStatus(t('memberDetail.statusInUse'));
        setFontColor('#595959');
        setBorder('1px solid #FFFFFF');
        setHoverBorder('1px solid #FF8B48');
        setBackgroundColor('#FFFFFF');
        setButtonImage(MemberShipHistoryInfoButtonImagePath);
      }
      // 시작 기한이 도래하지 않은 경우 //
      else if (moment().isBefore(moment(data.startDate))) {
        setStatus(t('memberDetail.statusPlannedUsage'));
        setFontColor('#FFFFFF');
        setBorder('1px solid #FFA800');
        setHoverBorder('1px solid #FFA800');
        setBackgroundColor('#FFA800');
        setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
      }
      // 예정된 기한이 지난경우 //
      else {
        setStatus(t('memberDetail.statusDaysExceeded'));
        setFontColor('#FFFFFF');
        setBorder('1px solid #F48080');
        setHoverBorder('1px solid #F48080');
        setBackgroundColor('#F48080');
        setButtonImage(MemberShipHistoryInfoWhiteButtonImagePath);
      }
    }
  }, [data])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionExitRef.current !== e.target
      && OptionPushMessageRef.current !== e.target
      && OptionExtendRef.current !== e.target
      && OptionDeleteRef.current !== e.target
      && OptionRefundRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  function mouseOver() {
    if (!data.isExpectedLocker) OptionButtonRef.current.style.opacity = 1;
  }

  function mouseLeave() {
    if (!data.isExpectedLocker) OptionButtonRef.current.style.opacity = 0;
  }

  // 새로 보여줘야하는 사용일수 표시 //
  function calcUseDate() {
    if (data.isExit) {
      return (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
    }
    else {
      if (moment(data.endDate).isAfter(moment())) return (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
      else return (moment(moment().format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
    }
  }

  // 결제 진행된 금액 표시 //
  function calcPaymentState() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);
      const paymentNameMap = { '카드': t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint') };

      if (totalPrice === 0) return t('memberDetail.payFree');
      else if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }


  // 사용 기간 표기 //
  function calcUsedDate() {
    if (data.isExit) return data.startDate.split('T')[0].replaceAll('-', '.').slice(2, 11) + ' - ' + data.endDate.split('T')[0].replaceAll('-', '.').slice(2, 11);
    else return data.startDate.split('T')[0].replaceAll('-', '.').slice(2, 11) + ' - ' + data.scheduledEndDate.split('T')[0].replaceAll('-', '.').slice(2, 11);
  }

  // 옵션 버튼 클릭시 //
  function onClickLockerOption() {
    if (!data.isExpectedLocker) setIsClicked(!isClicked);
  }

  // 몸체 눌렀을때 켜지기 //
  function onClickBody(e) {
    if (e.target === OptionButtonRef.current || OptionBoxRef.current.contains(e.target)) return;

    onClickLockerModify(data);
  }

  // 사용연장 버튼 클릭시 //
  function onClickExtends() {
    onClickLockerExtends(data);
    setIsClicked(false);
  }

  // 사용종료 버튼 클릭시 //
  function onClickStop() {
    onClickLockerExit(data);
    setIsClicked(false);
  }

  // 락커 환불 버튼 클릭시 //
  function onClickRefund() {
    onClickLockerRefund(data);
    setIsClicked(false);
  }

  // 내역삭제 버튼 클릭시 //
  function onClickDeleteHistory() {
    onClickDeleteLockerUsageHistory(data);
    setIsClicked(false);
  }

  // 정보수정 버튼 클릭시 //
  function onClickModify() {
    onClickLockerModify(data);
    setIsClicked(false);
  }

  return (
    <TopLevelWrapper zIndex={60 + size - index}>
      <LockerComponent
        zIndex={60 + size - index}
        border={border}
        hoverBorder={hoverBorder}
        backgroundColor={backgroundColor}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        onClick={onClickBody}>
        <Table>
          <Body>
            <Tr style={{ width: '192px', marginRight: '10px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '192px' }}>
                  <Text color={fontColor}>{data.lockerName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '150px', marginRight: `10px` }}>
              <Td>
                <TextWrapper style={{ maxWidth: '150px' }}>
                  <Text color={fontColor}>{calcUsedDate()}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '90px', marginRight: `10px` }}>
              <Td>
                <TextWrapper style={{ maxWidth: '90px' }}>
                  <Text color={fontColor}>{calcUseDate()}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '90px', marginRight: '10px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '90px' }}>
                  <Text color={fontColor}>{status}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '185px', marginRight: '10px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '180px' }}>
                  <Text color={fontColor}>{calcPaymentState()}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '175px', marginRight: '10px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '175px' }}>
                  <Text color={fontColor}>{moment(data.approvalDate).format('YY.MM.DD')}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <OptionButton ref={OptionButtonRef} src={buttonImage} onClick={onClickLockerOption} />
                <OptionWrapper ref={OptionBoxRef}>
                  {data.status === '사용중' && <Option ref={OptionExtendRef} onMouseDown={onClickExtends}>{t('memberDetail.extensionModal.btnExtendUsage')}</Option>}
                  {data.status === '사용중' && <Option ref={OptionExitRef} onMouseDown={onClickStop}>{t('memberDetail.btnEndUsage')}</Option>}
                  {data.status === '사용중' && <Option ref={OptionRefundRef} onMouseDown={onClickRefund}>{t('memberDetail.btnLockerRefund')}</Option>}
                  {data.status !== '사용중' && <Option ref={OptionDeleteRef} onMouseDown={onClickDeleteHistory}>{t('memberDetail.btnDeleteHistory')}</Option>}
                  <Option ref={OptionExtendRef} onMouseDown={onClickModify}>{t('memberDetail.btnModifyInfo')}</Option>
                </OptionWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </LockerComponent>
      {
        data.isRefund &&
        <ExpertComponentWrapper zIndex={60 + size - index - 1}>
          <LockerRefundInfoView
            data={data}
            onClickDeleteRefund={onClickDeleteLockerRefund}
            onClickModifyRefund={() => onClickModifyLockerRefund(data)}/>
        </ExpertComponentWrapper>
      }
      <ExtraUsageWrapper>
        {
          data.otherUsages.map((usage, usageIndex) => (
            <ExpertComponentWrapper key={usage.usageId} zIndex={60 + size - index - usageIndex - 2}>
              <LockerOtherUsageView
                data={usage}
                onClickLockerModify={onClickLockerModify}
                onClickLockerExtends={onClickLockerExtends}
                onClickLockerExit={onClickLockerExit}
                onClickLockerRefund={onClickLockerRefund}
                onClickDeleteLockerUsageHistory={onClickDeleteLockerUsageHistory}
                lockerRendering={lockerRendering}/>
            </ExpertComponentWrapper>
          ))
        }
      </ExtraUsageWrapper>
    </TopLevelWrapper>
  )
};

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;

  z-index: ${props => props.zIndex};
`;

const LockerComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1018px;
  height: 50px;

  border: ${props => props.border};
  border-radius: 30px;
  background-color: ${props => props.backgroundColor};
  
  z-index: ${props => props.zIndex};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: ${props => props.hoverBorder};
  }
`;


const Table = styled.table`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
  
  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;

const OptionButton = styled.img`
  opacity: 0;
    
  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
  height: 0px;
    
  z-index: 10;

  margin-top: 40px;
  margin-left: -30px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 74px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF8B48;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #FF8B48;
  }
`;

const ExtraUsageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;
